<template>
  <div>
   <v-row justify="space-around" align="center">
    <v-col cols="10" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
      <h1>Zones</h1>
    </v-col>
    <v-col cols="2" align-self="end" class="text-end">
        <v-menu
          offset-y
          v-if="editPermission"
        >
          <template v-slot:activator="{ on: menulist }">
            <v-tooltip top color="secondary" relative>
              <template v-slot:activator="{ on }">
                <v-btn icon dark size="35" color="green"  v-on="menulist" v-if="editPermission">
                  <v-icon v-on="on">watch_later</v-icon>
                </v-btn>
              </template>
              <span>Manage Time Windows</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(region, index) in regions"
              :key="index"
              @click="toggleEditDialog(region)"
            >
              <v-list-item-title>{{region.name}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn icon dark v-on="on" size="35" color="blue darken-1" v-on:click="$emit('export-btn-click')">
              <v-icon>cloud_download</v-icon>
            </v-btn>
          </template>
          <span>Export CSV</span>
        </v-tooltip>
    </v-col>
   </v-row>

   <v-row align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
    <v-col md="2" sm="10">
      <v-text-field
        v-model="propsHeader.search"
        prepend-inner-icon="fas fa-search"
        label="Search..."></v-text-field>
    </v-col>
    <v-col md="2" sm="10">
      <v-text-field
        prepend-inner-icon="fas fa-envelope"
        v-model="propsHeader.postcode"
        clearable
        label="Postcode..."
        type="number"
        v-on:change="$emit('postcode-change')"
        class="align-center pt-4"
      >
      </v-text-field>
    </v-col>
     <v-col md="2" sm="10">
       <v-autocomplete
         v-model="propsHeader.suburb"
         label="Choose suburb..."
         :items="propsHeader.suburbs"
         item-text="suburb"
         return-object
         clearable
         :search-input.sync="val"
         prepend-inner-icon="fas fa-search-location"
       >
       </v-autocomplete>
     </v-col>
    <v-col md="2" sm="10">
      <v-autocomplete
        v-if="propsHeader.isInternalUser"
        v-model="propsHeader.client"
        label="Choose Client..."
        :items="propsHeader.clients"
        item-text="name"
        item-value="zone"
        return-object
        clearable
        prepend-inner-icon="fas fa-user"
      >
      </v-autocomplete>
    </v-col>
    <v-col md="3" sm="10" class="d-flex justify-space-between">
      <v-switch
        v-if="propsHeader.isInternalUser"
        v-on:change="$emit('switch-change')"
        v-model="propsHeader.showRestricted"
        label="Show Restricted"
      >
      </v-switch>
      <v-switch color="orange"
                v-if="zoneViewAllPermission"
                :label="nonUsedSwitch"
                v-on:change="$emit('switch-change')"
                v-model="propsHeader.showNonUsed">
      </v-switch>
    </v-col>
   </v-row>

    <v-dialog v-model="editDialog" width="1200px">
      <ManageTimeWindows
        v-on:alert="$emit('alert')"
        :zone-view-permission="zoneViewAllPermission"
        :region="region"
        v-if="region"
        :toggle-edit-dialog="toggleEditDialog"
      ></ManageTimeWindows>
    </v-dialog>

  </div>
</template>

<script>
  import axios from 'axios'
  import ManageTimeWindows from "./ManageTimeWindows";

  export default {
    name: "ZonesHeader",
    components: {ManageTimeWindows},
    props: {
      propsHeader: Object,
    },
    data() {
      return {
        region: null,
        editDialog: false,
        val: null
      }
    },
    methods: {
      toggleEditDialog(region) {
        this.region = region;
        this.editDialog = true;
      }
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      zoneViewAllPermission() {
        return this.isInternalUser || this.$store.getters['auth/hasPermission']('zone_view_all');
      },
      regions() {
        return this.$store.state.auth.regions;
      },
      editPermission() {
        return this.$store.getters['auth/hasPermission']('zone_edit');
      },
      nonUsedSwitch() {
        let output = '';
        if (this.propsHeader.showNonUsed) {
          output = 'Show All';
        } else {
          output = 'In Use';
        }
        return output
      }
    },
      watch: {
          val(val) {
              this.$emit('input', val);
          },
          value(val) {
              this.val = val;
          }
      }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ZonesHeader.vue